import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PublicSpeaking = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.912 0H19.156a1 1 0 0 0-.998.998v19.966c0 .6.499 1.098.998 1.098h10.28l-8.384 20.466c-.2.499 0 1.197.6 1.397.498.2 1.097 0 1.397-.599l6.987-17.07v16.67a1 1 0 0 0 .998 1 1 1 0 0 0 .998-1v-16.67l6.987 16.97c.2.5.799.799 1.397.6.5-.2.799-.8.6-1.398L32.63 21.963h10.28c.6 0 .999-.5.999-1.099V.998c0-.499-.5-.998-.998-.998ZM20.254 19.866V2.096h21.56v17.77h-21.56ZM8.875 9.584c-1.397 0-2.595 1.198-2.595 2.595 0 1.398 1.198 2.596 2.595 2.596 1.398 0 2.595-1.198 2.595-2.596 0-1.397-1.197-2.595-2.595-2.595Zm-4.691 2.595a4.686 4.686 0 0 1 4.691-4.692 4.686 4.686 0 0 1 4.691 4.692 4.686 4.686 0 0 1-4.69 4.692 4.686 4.686 0 0 1-4.692-4.692ZM8.875 21.064c-3.793 0-6.787 2.995-6.787 6.788v3.994a1 1 0 0 1-.998.998c-.5 0-.998-.5-.998-.998v-3.994c-.1-4.891 3.892-8.884 8.783-8.884s8.884 3.993 8.884 8.884v3.994a1 1 0 0 1-.998.998c-.5 0-.999-.5-.999-.998v-3.994c-.1-3.793-3.194-6.788-6.887-6.788Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.382 29.25a1 1 0 0 1 .998.998v12.679a1 1 0 0 1-.998.998c-.5 0-.998-.499-.998-.998V30.348c-.1-.599.399-1.098.998-1.098ZM11.97 29.25a1 1 0 0 1 .998.998v12.679a1 1 0 0 1-.998.998c-.5 0-.999-.499-.999-.998V30.348c0-.599.4-1.098.998-1.098Z"
  }));
});
PublicSpeaking.displayName = 'PublicSpeaking';
PublicSpeaking.defaultProps = {
  'aria-label': 'PublicSpeaking'
};
export default PublicSpeaking;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/PublicSpeaking.js
// module id = 3073
// module chunks = 11